import React, { Component } from "react";
import { Image, Modal } from "semantic-ui-react";

class Imgmodal extends Component {
  render(props) {
    const classNames = this.props.className + " zoom";
    return (
      <Modal
        size="fullscreen"
        dimmer="blurring"
        basic
        trigger={
          <Image
            src={this.props.img}
            size={this.props.size}
            floated={this.props.floated}
            fluid
            className={classNames}
          />
        }
        closeOnDocumentClick={true}
        closeIcon
      >
        <Modal.Content>
          <Image src={this.props.img} fluid />
        </Modal.Content>
      </Modal>
    );
  }
}

export default Imgmodal;



// WEBPACK FOOTER //
// ./src/components/imgmodal.js